import { smartDocParamCondition_DispositionType_Admit, smartDocParamCondition_DispositionType_Discharge, smartDocParamCondition_DispositionType_Null, smartDocParamCondition_WorkingDiagnosis_DoesNotExists, smartDocParamCondition_WorkingDiagnosis_Exists } from "./types.js";
export const smartDocParamCondition_LabelMap = {
    // ################################### Working Diagnosis ###################################
    [smartDocParamCondition_WorkingDiagnosis_Exists]: 'Exists',
    [smartDocParamCondition_WorkingDiagnosis_DoesNotExists]: 'Does Not Exist',
    // ################################### Disposition Type ###################################
    [smartDocParamCondition_DispositionType_Null]: 'Null',
    [smartDocParamCondition_DispositionType_Admit]: 'Admit',
    [smartDocParamCondition_DispositionType_Discharge]: 'Discharge',
};
//# sourceMappingURL=consts.js.map